import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import { useMemo } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const contactListIds = {
    eu: '926148913',
    uk: '2109435518',
    de: '1061412141',
    fr: '774048908',
    it: '1152966046',
    es: '1399480182',
};

export default function Comp() {
    const { locale = 'eu' } = getLocal();
    const { t } = useLang('theProduct.SectionA');

    const fields = useMemo(() => {
        const EU_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: true },
            { type: 'multiple', id: '7596', value: [45], overwrite: false },
            { type: 'multiple', id: '9690', value: [12], overwrite: false },
        ];
        switch (locale) {
            case 'de':
                return [{ type: 'single', id: '4425', value: 1, overwrite: true }, ...EU_Fields];
            case 'es':
                return [{ type: 'single', id: '4426', value: 1, overwrite: true }, ...EU_Fields];
            case 'eu':
                return [{ type: 'single', id: '4427', value: 1, overwrite: true }, ...EU_Fields];
            case 'fr':
                return [{ type: 'single', id: '4428', value: 1, overwrite: true }, ...EU_Fields];
            case 'it':
                return [{ type: 'single', id: '4429', value: 1, overwrite: true }, ...EU_Fields];
            case 'uk':
                return [{ type: 'single', id: '4430', value: 1, overwrite: true }, ...EU_Fields];
            default:
                return [{ type: 'single', id: '4427', value: 1, overwrite: true }, ...EU_Fields];
        }
    }, [locale]);

    // 邮件
    const termsHtml = useMemo(() => {
        switch (locale) {
            case 'eu':
            case 'uk':
                return `I agree to EcoFlow's <a href="https://${locale}.ecoflow.com/policies/privacy-policy" target="_blank">Privacy Policy</a> and <a href="https://${locale}.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Service</a>.`;
            case 'de':
                return `Ich akzeptiere die <a href="https://de.ecoflow.com/policies/privacy-policy" target="_blank">Datenschutzbestimmungen</a> und <a href="https://de.ecoflow.com/policies/terms-of-service" target="_blank">Nutzungsbedingungen</a> von EcoFlow.`;
            case 'fr':
                return `J'accepte la <a href="https://fr.ecoflow.com/policies/privacy-policy" target="_blank">Politique de confidentialité</a> et les <a href="https://fr.ecoflow.com/policies/terms-of-service" target="_blank">Conditions d'utilisation</a> d'EcoFlow.`;
            case 'it':
                return `Accetto l’<a href="https://it.ecoflow.com/policies/privacy-policy" target="_blank">Informativa sulla privacy</a> e i <a href="https://it.ecoflow.com/policies/terms-of-service" target="_blank">Termini di servizio</a> di EcoFlow.`;
            case 'es':
                return `Acepto la <a href="https://es.ecoflow.com/policies/privacy-policy" target="_blank">Política de privacidad</a> y los <a href="https://es.ecoflow.com/policies/terms-of-service" target="_blank">Términos de servicio</a> de EcoFlow.`;
            default:
                return undefined;
        }
    }, [locale]);
    return (
        <div className={styles.comp} id="SectionA2">
            <EcoSpaceSmall />
            <div className="container">
                <div className="title">{t.rich('title', { h: (v: string) => <span>{v}</span> })}</div>
                <EcoEmail
                    contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.eu]}
                    source="WEB_NEW_PRODUCT_SUB"
                    fields={fields}
                    termsHtml={termsHtml}
                    tipsObj={{
                        placeholder: t('placeholder'),
                        tipsCheck: t('tipsCheck'),
                        successTips: t('successTips'),
                    }}
                    needTerms
                    subscribeData={{
                        sector_name: t.rich('title', {
                            h: (v: string) => {
                                v;
                            },
                        }),
                        entry_position: 3,
                    }}
                />
            </div>
            <EcoSpace />
        </div>
    );
}
